import { useState } from 'react';

import { Icon } from '@/icon/Icon';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui/DropdownMenu';

import type { DropdownElementProps, TPreferenceOption } from './Dropdown.types';

export function Dropdown(props: DropdownElementProps) {
  const { element, onChange, preferenceId } = props;
  const { name, value, options, description, required, custom_field_id } = element.attrs?.data || {};
  const [selectedOption, setSelectedOption] = useState<TPreferenceOption>(
    options?.find((option) => option.value === value),
  );

  if (!name || !custom_field_id) {
    return null;
  }

  const handleSelect = (optionValue: string) => {
    const selectedOption = options?.find((option) => option.value === optionValue);

    if (selectedOption) {
      onChange(selectedOption.value, preferenceId);
      setSelectedOption(selectedOption);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1">
        <label htmlFor={custom_field_id} className="font-medium text-sm text-gray-900">
          {name}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
        {description && <p className="text-xs text-gray-700 font-normal">{description}</p>}
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="flex items-center justify-between w-full px-3 py-2 text-sm text-left bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 isolate">
            <span>{selectedOption?.value || 'Select an option'}</span>
            <Icon name="CaretUpDown" type="caret-up-down" className="w-4 h-4 ml-2 text-gray-900 z-10" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[300px]" sideOffset={8} side="bottom" align="start">
          {options?.map((option) => (
            <DropdownMenuItem key={option.id} onSelect={() => handleSelect(option.value)} className="w-full">
              {option.value}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
